// extracted by mini-css-extract-plugin
module.exports = {"domain_limit_wrap":"index__domain_limit_wrap--3LoVw"};